import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { productCodes } from 'src/app/utility/enum/global-enum';
import { OtpService } from '../../service/otp/otp.service';

@Component({
  selector: 'app-online-generate-input',
  templateUrl: './online-generate-input.component.html',
  styleUrls: ['./online-generate-input.component.scss']
})
export class OnlineGenerateInputComponent implements OnInit {

  // Variables
  formDirectiveInputGeneration: FormGroupDirective;
  relationList: any = [];
  enrolProducts: any[] = [];
  dependentProducts: any = [];
  insuredName: string;
  groupPolicyNo: string;
  groupPolicyName: string;
  certificateNo: string;
  birthYear: number;
  enrolId: number;
  selectedPatientId = 0;
  selectedProductId = 0;
  private browserId: string;

  // Form Group
  inputGenerationForm = this.fb.group({
    groupPolicyNo: [null],
    groupPolicyName: [null],
    certificateNo: [null],
    birthYear: [null],
    productCode: [null, [Validators.required]],
    insuredName: [''],
    relationId: [null],
    enrolDependentId: [0],
    natureOfSickness: [null],
    enrolId: [null],
    componentValidatorId: [null],
    claimAmount: [null, [Validators.required, Validators.pattern("^[0-9]{1,18}")]
    ]
  });

  // Input and Output Decorator
  @Input() set dataRequiredForGeneratingInput(value) {
    if (value) {
      this.selectedProductId = 0;
      this.selectedPatientId = 0;
      this.resetFromSettings();

      this.relationList = value.relationList;
      this.enrolProducts = value.productList;
      this.dependentProducts = value.dependentProducts;
      this.insuredName = value.insuredName;
      this.groupPolicyNo = value.groupPolicyNo;
      this.groupPolicyName = value.groupPolicyName;
      this.certificateNo = value.certificateNo;
      this.birthYear = value.birthYear;
      this.enrolId = value.enrolId;
      this.browserId = value.browserId;

      this.inputGenerationForm.patchValue({
        groupPolicyNo: this.groupPolicyNo,
        certificateNo: this.certificateNo,
        groupPolicyName: this.groupPolicyName,
        birthYear: this.birthYear,
        insuredName: this.insuredName,
        enrolId: this.enrolId
      });
    }
  }

  // Input and Output Decorator
  @Input() set previousDataOfGeneratingInput(value) {
    if (value) {
      this.inputGenerationForm.patchValue({
        productCode: value.productCode,
        natureOfSickness: value.natureOfSickness,
        claimAmount: value.claimAmount,
      });
    }
  }


  @Output() onValidInput = new EventEmitter<any>();
  @Output() onProductChange = new EventEmitter<any>();
  @Output() onOtpSessionCancel = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private otpService: OtpService
  ) { }

  ngOnInit() {
  }


  dependentChange(event: any) {
    // reset this value to prevent form submission if productId is not selected.
    this.inputGenerationForm.patchValue({
      productCode: null
    });
    // if(event.value !=0){
    //   this.generatingImputForm.patchValue({
    //     enrolId : null
    //   });
    // }
    // else{
    //   this.generatingImputForm.patchValue({
    //     enrolId : this.enrolId
    //   });
    // }
  }

  goToUploadDocument(formDirective1: FormGroupDirective) {
    this.formDirectiveInputGeneration = formDirective1;
    this.notifyParentComponent();
  }


  resetFromSettings() {
    if (this.formDirectiveInputGeneration != null) {
      this.formDirectiveInputGeneration.resetForm();
    }
    // this.inputGenerationForm.reset();
    this.inputGenerationForm.reset({ enrolDependentId: 0 });
  }

  getEnrolDependentName(enrolDependentId) {
    const enrolDependent = this.relationList.find(x => x.enrolDependentId == enrolDependentId);
    return enrolDependent.name + ' & ' + enrolDependent.relationName;
  }


  notifyParentComponent() {

    const dependantId = this.inputGenerationForm.get('enrolDependentId').value;

    if (dependantId == null)
      this.inputGenerationForm.patchValue({ enrolDependentId: 0 });

    let product = {
      id: null,
      name: null,
      code: null,
      groupPolicyProductId: null
    }

    

    if(dependantId){
      const dependantProduct = this.dependentProducts.find(x => x.code == this.inputGenerationForm.get('productCode').value);
      product = {
        id: dependantProduct.productId,
        code: dependantProduct.code,
        name: dependantProduct.name,
        groupPolicyProductId: dependantProduct.groupPolicyProductId
      };
    }
    else{
      const enrolProduct = this.enrolProducts.find(x => x.code == this.inputGenerationForm.get('productCode').value);
      product = {
        id: enrolProduct.productId,
        code: enrolProduct.code,
        name: enrolProduct.name,
        groupPolicyProductId: enrolProduct.groupPolicyProductId
      };
    }

    const data = {
      enrolId: this.enrolId,
      enrolDependentId: dependantId,
      productId: product.id,
      productName: product.name,
      natureOfSickness: this.inputGenerationForm.get('natureOfSickness').value,
      claimAmount: this.inputGenerationForm.get('claimAmount').value,
      groupPolicyNumber: this.inputGenerationForm.get('groupPolicyNo').value,
      groupPolicyName: this.inputGenerationForm.get('groupPolicyName').value,
      certificateNumber: this.inputGenerationForm.get('certificateNo').value,
      insuredName: this.inputGenerationForm.get('insuredName').value,

      patientName: dependantId != 0 ?
        this.getEnrolDependentName(dependantId) :
        this.inputGenerationForm.get('insuredName').value,
      claimType: this.getClaimType(product),
      groupPolicyProductId: product.groupPolicyProductId
    };

    if (this.selectedPatientId != Number(data.enrolDependentId) || this.selectedProductId != Number(data.productId)) {
      this.onProductChange.emit(true);
    } else {
      this.onProductChange.emit(false);
    }
    this.selectedPatientId = data.enrolDependentId;
    this.selectedProductId = data.productId;
    this.onValidInput.emit(data);
  }

  getClaimType(product) {
    return product && product.code == productCodes.AMR ? 'Group Life' : 'Group Medical';
  }

  cancel() {
    this.otpService.otpSessionCancel(this.browserId).subscribe(res => {
      this.onOtpSessionCancel.emit(true);
    },
    err => {
      this.messageService.show(err.error.message, "error");
    });
  }
}
